import React from 'react'
import { Link, useParams } from 'react-router'
import styles from './MembershipNavbar.module.css'

const MembershipNavbar = () => {
    const { pageIdentifier } = useParams()
    return (
        <div className={styles.headerWrapper}>
            <div className={styles.allTitles}>
                <Link to={`/memberships/home`} className={pageIdentifier === 'home' ? styles.eachActiveTitle : styles.eachTitle}
                >
                    All Memberships
                </Link>
                <Link to={`/memberships/reports`} className={pageIdentifier === 'reports' ? styles.eachActiveTitle : styles.eachTitle}
                >
                    Reports
                </Link>
                <Link to={`/memberships/analytics`} className={pageIdentifier === 'analytics' ? styles.eachActiveTitle : styles.eachTitle}
                >
                    Analytics
                </Link>
                <Link to={`/memberships/settings`} className={pageIdentifier === 'settings' ? styles.eachActiveTitle : styles.eachTitle}
                >
                    Settings
                </Link>
            </div>
            <div className={styles.bTitles}>
                <Link to={`/memberships/help`}>
                    ? Help
                </Link>
            </div>
        </div>
    )
}

export default MembershipNavbar